<p>about-page works!</p>

<div *ngFor="let tags of tagsData;let i=index;">
 Feature Name: {{tags.Feature}}
</div>
